import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-wp-bot-form',
  templateUrl: './wp-bot-form.component.html',
  styleUrls: ['./wp-bot-form.component.css'],
})
export class WpBotFormComponent {
  url: string = '';
  id!: string;
  form!: FormGroup;

  resumenCards = [
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-message',
      bgClass: 'bg-white',
      desc: 'WpBot',
      route: '/hub',
    },
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-message',
      bgClass: 'bg-white',
      desc: 'BookingBot ',
      route: '/hub/chatbot',
    },
  ];

  constructor(
    private dataService: DataService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService
  ) {
    this.form = this.fb.group({
      user: ['anon324@email.com', [Validators.required]],
      ip: ['IP: 190.84.11.23 | Ciudad: Medellín', [Validators.required]],
      duration: ['2m 41s', [Validators.required]],
      intention: ['Solicitud de ayuda con pagos', [Validators.required]],
      summary: ['El usuario tuvo dificultades con el botón de pagar. La IA detecta frustración media y posibilidad de abandono. Se sugiere mejorar la UX en la pasarela móvil.', [Validators.required]],
      conclusions: [`- Lead calificado: X\n  - Compra final: X\n - Probabilidad de retorno: Media\n  - Recomendación UX: ¡`, [Validators.required]],
    });
  }

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.id = params['id'];

      if (this.id) {
        //this.getData();
      }
    });
  }

  isFieldInvalid(field: string) {
    return (
      this.form.get(field)?.invalid &&
      (this.form.get(field)?.dirty || this.form.get(field)?.touched)
    );
  }

  onSubmit(): void {
    if (this.id) {
      this.updateData();
    } else {
      this.createData();
    }
  }

  getData(): void {
    this.dataService.getData(`${this.url}/${this.id}`).subscribe((response) => {
      this.form.patchValue({
        description: response.description,
        value: response.value,
        frequency: response.frequency,
        dueDate: response.dueDate,
      });
    });
  }

  createData(): void {
    const formData = {
      ...this.form.value,
    };

    this.dataService
      .postData(`${this.url}/add`, formData)
      .subscribe((response) => {
        console.log('response add', response);
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
          this.form.reset();
          this.router.navigateByUrl('/numbers/accounting/external');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  updateData(): void {
    const formData = {
      ...this.form.value,
    };

    //console.log('formData up',formData)
    this.dataService
      .putData(`${this.url}/edit/${this.id}`, formData)
      .subscribe((response) => {
        console.log('response up', response);
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
          this.form.reset();
          this.router.navigateByUrl('/numbers/accounting/external');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }
}
